/* eslint-disable import/prefer-default-export */
const AlertFunction = function Alert({ selector, struct, speed }) {
  const init = () => {
    this.element = selector || '.alert';
    this.struct = struct || '<div class="alert"></div>';
    this.speed = speed || 500;

    document.addEventListener('click', (e) => {
      if (e.target.closest('.alert')) this.hide();
    });

    if (document.querySelector(this.element)) document.querySelector(this.element).remove();
    document.querySelector('body').insertAdjacentHTML('beforeend', this.struct);

    return this;
  };

  this.show = ({ text, mod = '--info', duration = 2000 }) => {
    clearTimeout(this.timeoutHandler);
    const self = document.querySelector(this.element);
    self.innerHTML = text;
    self.classList.add(mod);
    self.classList.add('--active');

    this.timeoutHandler = setTimeout(() => {
      this.hide();
    }, duration);
  };

  this.hide = () => {
    const self = document.querySelector(this.element);

    if (self) {
      self.classList.remove('--active');
      this.timeoutHandler = setTimeout(() => {
        self.innerHTML = '';
      }, this.speed);
    }
  };

  return init();
};

export const Alert = new AlertFunction({});

export default AlertFunction;
